import { render, staticRenderFns } from "./water-consent-profile-view.vue?vue&type=template&id=ac1affb2&"
import script from "./water-consent-profile-view.vue?vue&type=script&lang=ts&"
export * from "./water-consent-profile-view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports